import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/navBar`

/**
 * Add a new navbar
 * @param {Object} formData - { title: string, navItems: Array }
 */
export const addNavBarApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/add`, formData)
}

/**
 * Get all navbars (with hierarchical structure)
 * @param {string} [query] - Optional query string
 */
export const getNavBarsApi = (query = "") => {
  const queryString = query ? `?${query}` : ""
  return axiosInstance.get(`${serverUrl}/getNav${queryString}`)
}

/**
 * Get navbars with pagination and filtering
 * @param {string} [query] - Query string with params
 */
export const getNavBars = (query = "") => {
  const queryString = query ? `?${query}` : ""
  return axiosInstance.get(`${serverUrl}${queryString}`)
}

/**
 * Get navbar by ID
 * @param {string} id - Navbar ID
 */
export const getNavBarByIdApi = (id) => {
  return axiosInstance.get(`${serverUrl}/${id}`)
}

/**
 * Update a navbar
 * @param {string} id - Navbar ID
 * @param {Object} formData - { title?: string, navItems?: Array }
 */
export const updateNavBarApi = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/${id}`, formData)
}

/**
 * Soft delete a navbar
 * @param {string} id - Navbar ID
 */
export const deleteNavBarApi = (id) => {
  return axiosInstance.delete(`${serverUrl}/${id}`)
}

/**
 * Reorder nav items (for drag-drop)
 * @param {Object} formData - { navBarId: string, orderedItems: Array }
 */
export const reorderNavItemsApi = (formData) => {
  return axiosInstance.patch(`${serverUrl}/reorder`, formData)
}

/**
 * Convert item to sub-item or back to root item
 * @param {Object} formData - { navBarId: string, itemId: string, newParentId: string | null }
 */
export const convertToSubItemApi = (formData) => {
  return axiosInstance.patch(`${serverUrl}/convert-subitem`, formData)
}

// Centralized export for NavBar APIs
const navBarService = {
  addNavBarApi,
  getNavBarsApi,
  getNavBars,
  getNavBarByIdApi,
  updateNavBarApi,
  deleteNavBarApi,
  reorderNavItemsApi,
  convertToSubItemApi
}

export default navBarService
